import TemplateView from '../../../../TemplateView'
import PurchaseChooserCard from './PurchaseChooserCard'
import FreeChooserCard from './FreeChooserCard'

export default class FirstLicensePurchaseChooser extends TemplateView {
    constructor({
        openPurchaseLightBox = () => {},
        openGetFreeLightBox = () => {},
    }) {
        super()

        this.callbacks = {
            openPurchaseLightBox,
            openGetFreeLightBox,
        }
    }

    templateHtml() {
        return '<div class="chooser">' +
               '    <div class="title"><%=title%></div>' +
               '    <div class="cardsContainer">' +
               '        <div class="purchaseLicense"/>' +
               '        <div class="freeLicense"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'licenses.chooser.title'
        }
    }

    afterRender() {
        new PurchaseChooserCard({
            onPurchaseButtonClick: () => this.callbacks.openPurchaseLightBox(),
        }).init(this.find('.purchaseLicense'))
        new FreeChooserCard({
            onGetLicenseButtonClick: () => this.callbacks.openGetFreeLightBox(),
        }).init(this.find('.freeLicense'))
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/FirstLicensePurchaseChooser.js